module.exports = __webpack_public_path__ + "static/img/slide4_w.7bf2b1b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/caroussel/slide4_w.jpeg
// module id = AQsO
// module chunks = 1